/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_A2Inputs */

const en_pc_faq_a2 = /** @type {(inputs: Pc_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft is built by the ArtCraft team as part of its Crafting Apps, a set of free, open-source creative and office tools. Its source code is at github.com/storytold/pdfcraft and its project page is getartcraft.com/apps/pdfcraft.`)
};

const zh_pc_faq_a2 = /** @type {(inputs: Pc_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 由 ArtCraft 团队开发，属于 Crafting Apps 系列，这是一组免费开源的创意与办公工具。源代码位于 github.com/storytold/pdfcraft，项目页面为 getartcraft.com/apps/pdfcraft。`)
};

/**
* | output |
* | --- |
* | "PdfCraft is built by the ArtCraft team as part of its Crafting Apps, a set of free, open-source creative and office tools. Its source code is at github.com/s..." |
*
* @param {Pc_Faq_A2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_a2 = /** @type {((inputs?: Pc_Faq_A2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_A2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_a2(inputs)
	return zh_pc_faq_a2(inputs)
});
export { pc_faq_a2 as "pc.faq.a2" }